/**
 * @generated SignedSource<<e0e07845cbe720304c7c18c558c5a18f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateUserInput = {
  email: string;
  name: string;
  password: string;
};
export type UserListAddMutation$variables = {
  input: CreateUserInput;
};
export type UserListAddMutation$data = {
  readonly createUser: {
    readonly node: {
      readonly id: string;
    };
  };
};
export type UserListAddMutation = {
  response: UserListAddMutation$data;
  variables: UserListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateUserResult",
    "kind": "LinkedField",
    "name": "createUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserListAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserListAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "00babd7935306968d5559a7dd1caf39b",
    "id": null,
    "metadata": {},
    "name": "UserListAddMutation",
    "operationKind": "mutation",
    "text": "mutation UserListAddMutation(\n  $input: CreateUserInput!\n) {\n  createUser(input: $input) {\n    node {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d6a9a3624641ad01446205dc904e521d";

export default node;
